import { useTranslation } from 'react-i18next';
import EmptyState from '../../../../../shared-components/EmptyState';

const BASE = 'PAGES.ASSIGNMENTS.TEACHER.SECTION.TABLE.EMPTY_STATE';

function GroupsEmptyState({ archived }: { archived?: boolean }) {
  const { t } = useTranslation();

  return (
    <EmptyState
      variant="table"
      headerTitle={archived ? t(`${BASE}.ARCHIVED.TITLE`) : t(`${BASE}.TITLE`)}
      bodyText={archived ? t(`${BASE}.ARCHIVED.BODY`) : t(`${BASE}.BODY`)}
    />
  );
}

export default GroupsEmptyState;
